import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SetUm } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-tab',
  templateUrl: './sample-tab.component.html',
  styleUrls: ['./sample-tab.component.scss']
})
export class SampleTabComponent implements OnInit {

  @Input() block: SetUm[] = [];
  public activeId: number = 0;
  public domainWebsite = environment.urlApi;
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.helpersService.viewportScroll(event);
  }

  constructor(public helpersService: HelpersService) { }

  ngOnInit(): void {}

}
